import React, { FC } from "react";
import Text from "onnit-ui/lib/text";
import Box, { BoxProps } from "onnit-ui/lib/box/Box";
import Icon from "onnit-ui/lib/icon/Icon";
import { FiRefreshCw } from "react-icons/fi";

interface Props extends BoxProps {
    details: string[];
}

const SubscriptionDetailsText: FC<Props> = ({ details, ...boxProps }) => (details?.length ? (
    <Box display="flex" alignItems="flex-start" {...boxProps}>
        <Icon icon={FiRefreshCw} size={15} color="grays.5" mr={1} transform="translateY(2px)" flexShrink={0} />
        <Box>
            {details.map((detail, index) => (
                // Index is the only viable unique key. Should be OK b/c the order of these details don't change.
                // eslint-disable-next-line react/no-array-index-key
                <Text key={index} display="block" fontSize={1} color="grays.5" lineHeight={6}>
                    {detail}
                </Text>
            ))}
        </Box>
    </Box>
) : null);

export default SubscriptionDetailsText;
